import type { EnergyExposureFacilityOption } from '../ExposureService';

function normalizeLabelKey(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, ' ');
}

/**
 * Drop duplicate facility rows for exposure chart view dropdowns.
 * First by deal name (case-insensitive), then by display label so near-duplicate names
 * do not appear twice (Facility Concentration aggregates borrowers server-side; this mirrors
 * that intent for the facility picker list).
 */
export function dedupeExposureFacilityOptions(options: EnergyExposureFacilityOption[]): EnergyExposureFacilityOption[] {
  const byDealName = new Map<string, EnergyExposureFacilityOption>();
  for (const option of options) {
    const dealKey = option.dealName.trim().toLowerCase();
    if (!dealKey) {
      continue;
    }
    if (!byDealName.has(dealKey)) {
      byDealName.set(dealKey, option);
      continue;
    }
    const existing = byDealName.get(dealKey)!;
    if (option.isTerminated) {
      byDealName.set(dealKey, { ...existing, isTerminated: true });
    }
  }

  const byDisplayLabel = new Map<string, EnergyExposureFacilityOption>();
  for (const option of byDealName.values()) {
    const labelKey = normalizeLabelKey(option.displayLabel);
    if (!labelKey) {
      continue;
    }
    if (!byDisplayLabel.has(labelKey)) {
      byDisplayLabel.set(labelKey, option);
      continue;
    }
    const existing = byDisplayLabel.get(labelKey)!;
    if (option.isTerminated) {
      byDisplayLabel.set(labelKey, { ...existing, isTerminated: true });
    }
  }

  return [...byDisplayLabel.values()];
}
